
import { defineComponent, PropType } from 'vue'
import { IExternalReviewsItem } from '@entities/review/model/types'
export default defineComponent({
  name: 'ReviewLinksList',

  props: {
    platforms: {
      type: Array as PropType<IExternalReviewsItem[]>,
      required: true,
      default: () => []
    }
  },

  emits: ['closeModalLinks']
})
